import axios from 'axios';
import http from 'http';
import https from 'https';

/**
 * Is Prod
 */
const isProd = window.location.origin.includes('.iqos.com.ua')
  ? true
  : window.location.origin.includes('survey-ua.com')
  ? true
  : window.location.origin.includes('.zyn.com.ua')
  ? true
  : false;
// const isProd = false;
/**
 * Api Urls
 */

const apiUrls = {
  development: 'https://dev.execute-api.eu-west-1.amazonaws.com/dev',
  production: 'https://prod.execute-api.eu-west-1.amazonaws.com/prod'
};

/**
 * Api Url
 */
const apiUrl = isProd ? apiUrls.production : apiUrls.development;

/**
 * Cookie Api Url
 */
const cookieApiUrl = 'https://ss.iqos.com.ua/visitor-id-cookie';

/**
 * Tokens
 */

const tokens = {
  development: 'dev_token',
  production: 'prod_token'
};

/**
 * Token
 */
const token = isProd ? tokens.production : tokens.development;

/**
 * Instance
 */
const instance = axios.create({
  baseURL: apiUrl,
  headers: {
    'x-API-key': token,
    'Content-Type': 'application/json'
  }
});

const sendBeacon = (url: string, data: string) => {
  fetch(`${apiUrl}/${url}`, {
    method: 'POST',
    headers: {
      'x-API-key': token
      // 'Content-Type': 'application/json'
    },
    body: data,
    keepalive: true
  });
  // navigator.sendBeacon(`${apiUrl}/${url}`, payload);
};

/**
 * Instance Cookie
 */
const instanceCookie = axios.create({
  baseURL: cookieApiUrl
});

export { instance, instanceCookie, sendBeacon };
